<template lang="pug">
  FormModal.modal-new-collection(title="New Collection", endpoint="collections", :data="data", v-bind="$attrs", @success="onSuccess")
    Tabs
      Tab(title="Details")
        InputGroup(label="Privacy", name="type", v-if="user.hasPermission('collections.shared_manage') && user.hasPermission('collections.manage')")
          Radios(v-model="data.type", inline)
            Radio(value="partner", @change="onTypeChange()")
              Icon(icon="users")
              div
                div: strong Shared Collection
                div.option-label Shared among all members of your team.
            Radio(value="personal", @change="onTypeChange()")
              Icon(icon="user")
              div
                div: strong Personal Collection
                div.option-label Private and visible only to you.

        InputGroup(label="Title", name="name")
          TextInput(v-model="data.name", prepend-icon="collection", textarea, :rows="1", auto-focus)

        InputGroup(label="Subtitle", name="header_message")
          TextInput(v-model="data.header_message", textarea)

        InputGroup(label="Folder", name="folder_id")
          Select(v-model="data.folder_id", :endpoint="`options/${data.type}/folders`", option-label="label", prepend-option="No Folder", prepend-icon="folder", prepend-icon-prefix="fas")

        InputGroup(label="Internal code — optional", name="code", description="Add codes for internal use only (eg Draft, Tour Code or Partner-Specific). Press 'enter' after each code to apply.")
          TagsInput(v-model="data.code", prepend-icon="tag")

      Tab(title="Visibility")
        InputGroup(label="Language", name="language_id")
          Select(v-model="data.language_id", endpoint="options/languages", prepend-icon="language", prepend-icon-prefix="fas")

        InputGroup(label="Markets — optional", name="partner_market_ids", description="Show this content only to users in certain markets. Leave blank to make it visible everywhere. Press 'enter' after each market to apply.")
          MultiSelect(v-model="data.partner_market_ids", placeholder="Enter market...", endpoint="search/partner-markets", searchable)

        PublishAtInput(v-model="data.inspires_publish_at", label="Make public on inspires - optional", description="Pick a date to make this content public. Leave blank to keep it private (you can share selectively using the “Invite URL”).")

        ExpiresAtInput(v-model="data.expires_at", description="Pick a date to automatically remove this content from inspires.to — applies to both public and private versions.")

        InputGroup(label="Private for Sales Team", name="published_selectively_on_inspires")
          ToggleSwitch(v-model="data.published_selectively_on_inspires", :label="`Turn on to show private, invite-only content to your sales team at inspires.to/${user.partner.slug}/sales`", rounded)

        InputGroup(label="Advanced Editing", name="inspires_advanced_customisations_enabled")
          ToggleSwitch(v-model="data.inspires_advanced_customisations_enabled", label="Allow Signature to customize this content experience.", rounded)

        InputGroup(label="Tags — optional (Beta)", name="tag", description="Add tags to help users find related content (e.g., promotions, regions like Arctic, Med). Visible to all users (unlike Internal Codes). Press 'enter' after each tag to apply.")
          TagsInput(v-model="data.tags", placeholder="Enter tags...", prepend-icon="tag")
</template>

<script>
import { mapGetters } from "vuex"
import { Tabs, Tab } from "@syntax51/app-kit"
import ExpiresAtInput from "@/components/Form/ExpiresAtInput.vue"
import PublishAtInput from "@/components/Form/PublishAtInput.vue"

export default {
  components: {
    ExpiresAtInput,
    PublishAtInput,
    Tabs,
    Tab
  },
  props: {
    type: {
      type: String,
      default: null
    },
    folder_id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    data: {
      type: null,
      name: "",
      header_message: null,
      folder_id: null,
      language_id: 1,
      code: [],
      partner_market_ids: [],
      inspires_publish_at: null,
      expires_at: "",
      published_selectively_on_inspires: false,
      inspires_advanced_customisations_enabled: false,
      tags: []
    }
  }),
  computed: {
    ...mapGetters({
      user: "auth/user"
    })
  },
  created() {
    if (this.type === "partner" && this.user.hasPermission("collections.shared_manage")) {
      this.data.type = "partner"
    } else if (this.type === "personal" && this.user.hasPermission("collections.manage")) {
      this.data.type = "personal"
    } else if (this.user.hasPermission("collections.shared_manage") && this.user.hasPermission("collections.manage")) {
      this.data.type = "partner"
    } else if (this.user.hasPermission("collections.shared_manage")) {
      this.data.type = "partner"
    } else if (this.user.hasPermission("collections.manage")) {
      this.data.type = "personal"
    }

    this.data.folder_id = this.folder_id
  },
  methods: {
    onTypeChange() {
      this.data.folder_id = null
    },
    onSuccess(result) {
      this.$notification.success(`Collection **${this.data.name}** successfully created.`)
      this.$emit("close", result)
    }
  }
}
</script>

<style>
.modal-new-collection,
.modal-edit-collection,
.modal-duplicate-collection,
.modal-new-folder,
.modal-edit-folder {
  .form-check-group {
    @apply space-x-3;
  }

  .form-check {
    @apply w-1/2;

    &-custom-input {
      @apply hidden;
    }

    &.is-checked .form-label {
      @apply border-primary-default;
    }
  }

  .form-label {
    @apply block rounded border-2 border-solid py-6 pl-6 pr-8;
  }

  .form-check-content {
    @apply ml-0 flex;

    .icon {
      @apply mr-3 mt-2 w-12 text-2xl text-supplement;
    }
  }

  .option-label {
    @apply text-supplement;
  }
}
</style>
